<script>
  import { createEventDispatcher } from 'svelte';
  import { Session, Telekinesis } from 'telekinesis-js';
  import Button from "./Button.svelte";
  import Container from './Container.svelte';
  import Dropdown from './Dropdown.svelte';
  import NamePrompt from './NamePrompt.svelte';
  import NotebookCell from './NotebookCell.svelte';
  import WaitingFor from './WaitingFor.svelte';

  // export let cells;
  // export let updateScratchpad;
  export let notebook;

  const dispatch = createEventDispatcher();
  let cells, name, now;
  let removedCells = [];

  const updateNotebook = async (newCells) => {await notebook.update(newCells).data};

  const updateCells = async () => {
    if (!name) {
      name = await notebook.name._timeout(10);
    }
    cells = await notebook.data._timeout(10);
  }

  // $: async () => {
  //   cells = await note
  // }
  
  let queue = [];
  let logPromises;
  let executionId = 0;

  const originalLog = console.log; 
  const originalError = console.error;

  const encode = async (args) => {
    const tempSession = new Session();
    const tempSessionKey = await tempSession.sessionKey.publicSerial();
    return [await Promise.all(args.map(async obj => {
      try {
        const out = await new Telekinesis(undefined, tempSession)._encode(obj)
        // originalLog(out, obj)
        return out;
      } catch(e) {
        originalError('error in Scratchpad.encode', e)
        return await new Telekinesis(undefined, tempSession)._encode(obj.toString());
      }
    })), tempSessionKey];
  }
  
  const execute = async () => {
    while (queue.length) {
      logPromises = [];
      const thisExecutionId = executionId;
      // console.log(thisExecutionId, '>>', queue[0])

      let cell = cells[queue[0]];
      
      console.log('executing', queue[0])

      console.log = (...args) => {
        if (thisExecutionId == executionId) {
          logPromises.push(new Promise(async r => {
            let index = queue[0];
            originalLog(...args)
            const out = await encode(args)
            cells[index] = {...cells[index], output: [...cells[index].output, ['log', ...out]]};
            r();
          }))
        } else {
          originalLog('Unexpected message', ...args);
          throw 'Cancelled Execution';
        }
      } 
      console.error = (...args) => {
        if (thisExecutionId == executionId) {
          logPromises.push(new Promise(async r => {
            let index = queue[0];
            originalError(...args);
            const out = await encode(args)
            cells[index] = {...cells[index], output: [...cells[index].output, ['error', ...out]]};
            r()
          }))
        } else {
          originalError('unexpected message', ...args);
          throw 'Cancelled Execution';
        }
      } 
      let intervalUpdateNowVariable
      const index = queue[0]
      try {
        cell = cells[index];
        cell.execute_start = Date.now()/1000;
        cell.execute_end = null;
        const updateNowVariable = () => {now = Date.now()/1000}
        updateNowVariable()
        intervalUpdateNowVariable = setInterval(updateNowVariable, 100);
        let wrapper = window.eval("async () => {"+ cell.input + "}");
        let out = await wrapper()//.catch(e => console.info('>>>>>>', e));
        if (executionId == thisExecutionId) {
          if (out !== undefined && out !== null) {
            // console.info('output', out, cells[index])
            cells[index] = {...cells[index], output: [...cells[index].output, ['output', ...(await encode([out]))]]};
            // originalLog('out', cells)
          }
        }
      } catch (e) {
        // originalError(e)
        console.error(e)
        if (executionId == thisExecutionId) {
          queue = [];
        }

      } finally {
        if (thisExecutionId == executionId) {
          // cell.execute_end = Date.now()/1000;
          cells[index] = {...cells[index], execute_end: Date.now()/1000};
          clearInterval(intervalUpdateNowVariable);
          await Promise.all(logPromises);

          console.log = originalLog;
          console.error = originalError;
          executionId += 1;
          // console.log(cells[queue[0]])
          queue = queue.slice(1);
          await updateNotebook(cells)
        }
      }
    }
  }

</script>

<div style='display: flex; align-items: center; font-size: small; gap: 4px'>
  <!-- <Button style='margin: 0; background-color: transparent; color: var(--foreground)'>Delete</Button> -->
  <Dropdown title="⋮" style="background-color: var(--background); color: var(--foreground);"  >
    <NamePrompt name={'Rename'} style="background-color: var(--background); color: var(--foreground); width: 100%;"
      originalChildName={name || ''}
      on:submit={async ({detail}) => {
        await notebook.rename(detail)
        await dispatch('update')
      }} />
    <Button on:click={async () => {
      await notebook.remove();
      await dispatch('update')
    }} style='background-color: #fee; color: var(--tertiary); width: 100%'>🗑 Delete</Button>

  </Dropdown>
  <Button disabled={removedCells.length <= 0} on:click={async () => {
    let [position, cell] = removedCells.pop();
    removedCells = [...removedCells];
    cells = [...cells.slice(0, position), cell, ...cells.slice(position)]
    await updateNotebook(cells);
  }}>{'↶'}</Button>
  <!-- <Button on:click={async () => {
    await notebook.remove();
    await dispatch('update')
  }} style='background-color: transparent; color: var(--tertiary)'>Rename</Button> -->
  <div style='flex-grow: 1'/>
  <span>Runtime: </span>
  <select>
    <option>Javascript (browser)</option>
    <!-- <option>Markdown</option> -->
  </select>

</div>
<Container>
{#await updateCells()}
  <WaitingFor />
{:then _}
  {#if cells?.length}
    {#each cells as cell, i}
      <NotebookCell cell={cell} queuePosition={queue.indexOf(i)} now={now}
        on:remove={async () => {
            removedCells = [...removedCells, [i, cells[i]]];
            cells = [...cells.slice(0, i), ...cells.slice(i+1)]; 
            // console.log(cells)
            if (queue[0] == i) {
              executionId += 1;
            }
            queue = queue.filter(x => x != i).map(x => x < i ? x : x-1 )
            await updateNotebook(cells)
          }
        } on:add={async () => {cells = [...cells.slice(0, i+1), {input: ''}, ...cells.slice(i+1)]; await updateNotebook(cells)}
        } on:run={async () => {
          if (queue.indexOf(i) == -1) {
            cell.output = [];
            updateNotebook(cells).then(() => null)
            queue = [...queue, i]; 
            if (queue.length == 1) {
              execute();
            }
          }
        }} on:cancel={ () => {
          if (queue[0] == i) {
            executionId += 1;
            console.log = originalLog;
            console.error = originalError;
          }
          queue = queue.filter(x => x != i)
        }} on:update={async () => await updateNotebook(cells)}
      />

    {/each}
  {:else}
    <Button on:click={() => {cells = [{input: ''}]}}>+</Button>
  {/if}
{/await}
</Container>

